import { useCallback, useMemo } from "react";
import confetti from "canvas-confetti";
import { VisualContextValue } from "@swiggy-private/checkout-core";
import { isEmpty, captureError } from "@swiggy-private/core-ui";
import { CONFETTI_TYPES } from "@checkout-main/constants/Confetti";

import { initCanvas } from "@checkout-main/utils/Confetti";

export const useVisualEffects = (): VisualContextValue => {
    const showConfetti = useCallback((type: string) => {
        try {
            const canvas = initCanvas();
            if (!canvas) {
                return;
            }
            const confettiInstance = confetti.create(canvas, { resize: true });
            const confettiProps = CONFETTI_TYPES[type];
            if (!isEmpty(confettiProps)) {
                requestAnimationFrame(() => {
                    confettiInstance(confettiProps)?.then(() => {
                        canvas.remove();
                    });
                });
            }
        } catch (err) {
            captureError(err);
        }
    }, []);

    const visualEffectValue = useMemo(() => {
        return {
            showConfetti,
        };
    }, [showConfetti]);

    return visualEffectValue;
};
